import posthog from "posthog-js";
import { useRouteMatch } from "react-router-dom";
import { EditBundleApiRequirements, EditBundlePage } from "./EditBundlePage";
import { useEffect, useRef, useState } from "react";
import { Routes } from "@greeter-venue/utility/Routes";
import { useIonViewWillEnter } from "@ionic/react";
import { PosthogIdentifier } from "@greeter-venue/App";
import { PostHog } from "posthog-js";
import { useGreeterVenueApi } from "@greeter/matter";
import { useQuery } from "@tanstack/react-query";
import { FeatureFlags } from "@greeter/core";

const posthogKey = "beta.features.bundles.posthog.allowSessionRecordings";

function allowPosthog() {
  sessionStorage.setItem(posthogKey, "true");
}

function disallowPosthog() {
  sessionStorage.setItem(posthogKey, "false");
}

export function EditBundlePageApiHandler(props: {
  api?: EditBundleApiRequirements;
}) {
  const [_posthog, setPosthog] = useState<PostHog>();
  const [trackingAllowed, setTrackingAllowed] = useState(false);
  const routeMatch = useRouteMatch<{ id?: string }>(
    Routes.mainGroup.venueTab.editBundle.template()
  );
  const params = routeMatch?.params;

  const dialogRef = useRef<HTMLDialogElement | null>(null);

  useIonViewWillEnter(() => {
    const v = sessionStorage.getItem(posthogKey);
    const allowedToRecord = v === "true" ? true : false;
    console.log("allowedToRecord", allowedToRecord);
    setTrackingAllowed(allowedToRecord);

    if (!dialogRef.current) {
      return;
    }

    if (!allowedToRecord) {
      dialogRef.current.showModal();
    }
  }, []);

  useEffect(() => {
    if (trackingAllowed) {
      console.log("Setting up posthog");
      setPosthog(
        posthog.init("phc_6OUeu1GfKjIxHDdpALF280hTbD5ixWEAB75rtPqk28B", {
          api_host: "https://eu.i.posthog.com",
          person_profiles: "identified_only",
          // autocapture: true,
          mask_all_text: false,
          autocapture: {
            url_allowlist: [
              "http://localhost:4200/edit-bundle",
              "http://localhost:4200/edit-bundle/.*",
              "https://venue.greeter.dk/edit-bundle",
              "https://venue.greeter.dk/edit-bundle/.*",
            ],
          },
        })
      );
    }
  }, [trackingAllowed]);

  const { api } = useGreeterVenueApi();
  const featureFlagsQuery = useQuery({
    queryKey: ["venueFeatureFlag", "bundlepicker.v2.venue"],
    async queryFn() {
      return await api.fetchVenueFeatureFlag({ name: "bundlepicker.v2.venue" });
    },
  });
  const isActive = featureFlagsQuery.data?.active;

  const featureFlags: FeatureFlags = new Map();
  featureFlags.set("bundlepicker.v2", isActive ?? false);

  // TODO: We need to be able to edit the thing.
  return (
    <div>
      {trackingAllowed && <PosthogIdentifier />}
      <EditBundlePage
        api={api}
        bundleId={params?.id}
        featureFlags={featureFlags}
      />
      {/* Track consent for recording sessions */}
      {/*<dialog
        ref={(r) => (dialogRef.current = r)}
        className="border-radius-lg border-light p-1rem"
        style={{ textAlign: "left" }}
      >
        <p>
          For at teste denne feature, vil vi gerne tracke hvordan du bruger den
          så vi kan tilrette og analysere på fejl der opstår eller forvirringer
          der forekommer. Til dette vil{" "}
          <a
            href="https://posthog.com/docs/privacy/gdpr-compliance"
            style={{
              textDecoration: "underline",
              color: "var(--gm-color-dark-primary)",
              fontWeight: "bold",
            }}
          >
            Posthog
          </a>{" "}
          blive brugt, og din email, du er logget ind med, vil blive brugt til
          at identificere dig med, så vi kan opfølge i tilfælde af det bliver
          nødvendigt til afklaring
        </p>

        <p>
          Det er udelukkende til udviklingsformål, så vi kan skabe den bedste
          app muligt, ved henvendelser ang. sletning af tracking data skal du
          bare skrive til Christoffer direkte, eller til mig på{" "}
          <a
            href="mailto:bjarke@greeter.dk"
            style={{
              textDecoration: "underline",
              color: "var(--gm-color-dark-primary)",
              fontWeight: "bold",
            }}
          >
            bjarke@greeter.dk
          </a>
        </p>

        <p>
          Hvis du ikke ønsker dette, skal du trykke <q>Send mig tilbage</q>, så
          bliver du sendt tilbage til hjemmeskærmen 😊
        </p>
        <p>- Bjarke, udvikleren i Greeter</p>
        <form
          onSubmit={(ev) => ev.preventDefault()}
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "1rem",
            justifyContent: "space-between",
          }}
        >
          <button
            style={{
              padding: "0.5rem 1rem",
              borderRadius: "var(--gm-border-radius-md)",
              backgroundColor: "var(--gm-color-red)",
              color: "var(--gm-color-light-primary)",
              fontWeight: "bold",
            }}
            onClick={() => {
              disallowPosthog();
              dialogRef.current?.close();
              history.push(Routes.venueTab.root.route());
            }}
          >
            Tilbage
          </button>
          <button
            style={{
              padding: "0.5rem 1rem",
              borderRadius: "var(--gm-border-radius-md)",
              backgroundColor: "var(--gm-color-primary-highlight)",
              color: "var(--gm-color-light-primary)",
              fontWeight: "bold",
            }}
            onClick={() => {
              allowPosthog();
              dialogRef?.current?.close();

              window.location.reload();
            }}
          >
            Tillad
          </button>
        </form>
      </dialog>*/}
    </div>
  );
}
